
import { NavItem } from '../types';
import { MessageCircle } from 'lucide-react';

const chatItems: NavItem[] = [
  {
    title: 'Chat',
    path: '/app/chat',
    icon: MessageCircle,
    requiredPermissions: ['chat.read'],
  }
];

export default chatItems;
